"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.commonChartDefaults = function (name) {
    return {
        lang: {
            thousandsSep: ',',
            accessibility: name
                ? {
                    chartContainerLabel: name + " chart",
                    defaultChartTitle: name + " chart",
                    screenReaderSection: {
                        beforeRegionLabel: name + " chart screen reader information.",
                    },
                }
                : {},
        },
        chart: {
            //styledMode:true,
            className: 'DataChart',
            style: {
                fontFamily: 'Roboto',
            },
            backgroundColor: 'transparent',
            plotBorderWidth: 1,
            plotBorderColor: '#e0dcdc',
        },
        title: undefined,
        credits: {
            enabled: false,
        },
        xAxis: {
            labels: {
                style: {
                    fontSize: '1rem',
                    color: '#252525',
                },
            },
            title: undefined,
            tickLength: 0,
            plotBands: [
                {
                    color: '#ffffff',
                    from: 0,
                    to: 9999999999999,
                },
            ],
            gridLineWidth: 1,
        },
        yAxis: {
            labels: {
                style: {
                    fontSize: '1rem',
                    color: '#252525',
                },
            },
            title: undefined,
            gridLineWidth: 1,
        },
        tooltip: {
            shadow: true,
            backgroundColor: '#ffffff',
            borderWidth: 0,
            borderRadius: 0,
            padding: 20,
        },
        legend: {
            enabled: false,
        },
    };
};
exports.columnChartDefaults = {
    chart: {
        className: 'DataChart DataChart-column',
    },
    colors: ['#536b39', '#939393'],
    plotOptions: {
        column: {
            borderWidth: 1,
            borderColor: '#fff',
            pointPadding: 0,
        },
    },
    xAxis: {
        gridLineWidth: 0,
    },
    responsive: {
        rules: [
            {
                condition: { minWidth: 0 },
                chartOptions: {
                    plotOptions: {
                        column: { groupPadding: 0.2 },
                    },
                },
            },
            {
                condition: { minWidth: 600 },
                chartOptions: {
                    plotOptions: {
                        column: { groupPadding: 0.3 },
                    },
                },
            },
            {
                condition: { minWidth: 900 },
                chartOptions: {
                    plotOptions: {
                        column: { groupPadding: 0.33 },
                    },
                },
            },
            {
                condition: { minWidth: 1200 },
                chartOptions: {
                    plotOptions: {
                        column: { groupPadding: 0.38 },
                    },
                },
            },
        ],
    },
    legend: {
        enabled: false,
        itemStyle: {
            fontSize: '8px',
            fontWeight: 'regular',
        },
        align: 'right',
        verticalAlign: 'top',
    },
    tooltip: {
        enabled: false,
    },
};
exports.areaChartDefaults = {
    chart: {
        className: 'DataChart DataChart-area',
    },
    colors: ['#536b39', '#939393'],
    legend: {
        enabled: false,
    },
    xAxis: {
        tickPixelInterval: 60,
    },
    yAxis: {
        title: undefined,
        tickPixelInterval: 60,
    },
    plotOptions: {
        area: {
            marker: {
                enabled: false,
            },
            lineWidth: 3,
            fillColor: {
                pattern: {
                    width: 4,
                    height: 4,
                    opacity: 0.4,
                    image: require('./media/pattern-green.gif'),
                    id: '1',
                    aspectRatio: 1,
                    path: '',
                    color: '',
                    backgroundColor: '',
                    patternTransform: '',
                },
            },
        },
    },
};
exports.lineChartDefaults = {
    colors: ['#536b39', '#939393'],
    legend: {
        enabled: false,
    },
    xAxis: {
        tickPixelInterval: 60,
    },
    yAxis: {
        title: undefined,
        tickPixelInterval: 60,
    },
    plotOptions: {
        line: {
            marker: {
                enabled: false,
            },
            lineWidth: 3,
        },
    },
    tooltip: {
        enabled: false,
    },
};
exports.pieChartDefaults = {
    chart: {
        plotBorderWidth: 0,
        margin: [0, 0, 0, 0],
        spacing: [0, 0, 0, 0],
    },
    colors: [
        '#7491b2',
        '#675073',
        '#546a3a',
        '#9dbdc3',
        '#16719f',
        '#767676',
        '#024578',
        '#a370b7',
        '#252525',
    ],
    tooltip: {
        headerFormat: '',
        pointFormat: '{point.name}: <strong>{point.percentage:.2f}%</strong>',
    },
    plotOptions: {
        pie: {
            borderColor: '',
            cursor: 'pointer',
            size: '100%',
            innerSize: '65%',
            dataLabels: {
                enabled: false,
            },
        },
    },
};
